import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import {getExportFetchURL, getFetchURL} from "../helpers/actionHelpers";
import {getSessionCompanyId} from "../helpers/sessionHelper";

const initialState = {
  passLogList: [],
  passLogHistoryList: [],
  passLogHistoryFreeCount: {}
};

export const fetchPassLogHistory = createAsyncThunk("passLog/fetchPassLogHistory", async (passLogId, { dispatch }) => {
  const response = await axios.get(getFetchURL(`/reservation/pass-log-history/${passLogId}`));
  return response.data;
});

export const fetchExpiredPassLog = createAsyncThunk("passLog/fetchExpiredPassLog", async (_, { dispatch }) => {
  const response = await axios.get(getFetchURL(`/pass-log/company/get/expired/${getSessionCompanyId()}`));
  return response.data;
});

export const fetchNotExpiredPassLog = createAsyncThunk("passLog/fetchNotExpiredPassLog", async (_, { dispatch }) => {
  const response = await axios.get(getFetchURL(`/pass-log/company/get/not-expired/${getSessionCompanyId()}`));
  return response.data;
});

export const insertPassLog = createAsyncThunk("passLog/insertPassLog", async (apiData, { dispatch }) => {
  const options = {
    method: "PUT",
    data: apiData,
    headers: { "Content-Type": "application/json" },
    url: getFetchURL("/pass-log/add")
  };

  const response = await axios(options).then((_) => {
    dispatch(fetchNotExpiredPassLog());
  });

  return response.data;
});

export const deletePassLog = createAsyncThunk("passLog/deletePassLog", async (id, { dispatch }) => {
  const options = {
    method: "delete",
    url: getFetchURL(`/pass-log/delete/${id}`)
  };

  const response = await axios(options).then((_) => {
    dispatch(fetchNotExpiredPassLog());
  });

  return response.data;
});

export const editPassLog = createAsyncThunk("passLog/editPassLog", async (apiData, { dispatch }) => {
  const options = {
    method: "PUT",
    data: apiData,
    headers: { "Content-Type": "application/json" },
    url: getFetchURL("/pass-log/edit")
  };

  const response = await axios(options).then((_) => {
    dispatch(fetchNotExpiredPassLog());
  });

  return response.data;
});

export const checkFreePassLogHistory = createAsyncThunk("passLog/checkFreePassLogHistory", async (passLogId, { dispatch }) => {
  const response = await axios.get(getFetchURL(`/pass-log/check/${passLogId}`));
  return response.data;
});

export function exportPassLogPdf(passLogId) {
  window.open(getExportFetchURL(`/pdf-file/pass-log/${passLogId}`));
}

export const passLogSlice = createSlice({
  name: "passLog",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchExpiredPassLog.fulfilled, (state, action) => {
        state.passLogList = action.payload;
      })
      .addCase(fetchNotExpiredPassLog.fulfilled, (state, action) => {
        state.passLogList = action.payload;
      })
      .addCase(fetchPassLogHistory.fulfilled, (state, action) => {
        state.passLogHistoryList = action.payload;
      })
      .addCase(checkFreePassLogHistory.fulfilled, (state, action) => {
        state.passLogHistoryFreeCount = action.payload;
      });
  }
});

export default passLogSlice.reducer;
